import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">Search Actor</label>
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              value={filters?.search || ''}
              onChange={(e) => handleFilterChange('search', e?.target?.value)}
              placeholder="Search by name..."
              className="w-full pl-10 pr-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
          </div>
        </div>

        {/* Quality Threshold */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">Quality Threshold</label>
          <select
            value={filters?.qualityThreshold || 'all'}
            onChange={(e) => handleFilterChange('qualityThreshold', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">All Quality Levels</option>
            <option value="90">Excellent (90+)</option>
            <option value="75">Good (75+)</option>
            <option value="50">Fair (50+)</option>
          </select>
        </div>

        {/* Completion Status */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">Completion Status</label>
          <select
            value={filters?.completionStatus || 'all'}
            onChange={(e) => handleFilterChange('completionStatus', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="all">All Statuses</option>
            <option value="complete">Complete (100%)</option>
            <option value="in-progress">In Progress</option>
            <option value="not-started">Not Started</option>
          </select>
        </div>

        {/* Sort By */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">Sort By</label>
          <select
            value={filters?.sortBy || 'qualityScore'}
            onChange={(e) => handleFilterChange('sortBy', e?.target?.value)}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="qualityScore">Quality Score</option>
            <option value="linesRecorded">Lines Recorded</option>
            <option value="completion">Completion %</option>
            <option value="name">Name (A-Z)</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
